export default {
  // headers / chrome
  bellTitle: "您的通知",
  viewAll: "查看所有通知",
  pageTitle: "所有通知",

  // tabs
  tabAll: "全部",
  tabUnread: "未读",
  tabRead: "已读",

  // empty states
  selectBusiness: "请选择企业资料以查看通知",
  noAlert: "暂无通知",
  noNew: "暂无新通知",
  noList: "暂无通知",
  notFound: "未找到相关通知",
  checkAgain: "请重新检查或联系管理员",

  // defaults
  unnamed: "未具名",
  notSpecified: "未指定",

  // buttons
  viewProfile: "查看申请人资料",

  // descriptions
  descViewProfile: "您可以查看申请人的资料。",
  descViewStatusList: "您可以查看 {position} 职位所有申请人的状态列表。",

  // notification messages
  msgApplied: "{name} 已申请 {position} 职位。",
  msgEditApply: "{name} 已修改 {position} 职位的申请。",
  msgOfferByYou: "您已向 {name} 发送 {position} 职位的录用邀请。",
  msgOfferByOther: "其他管理员已向 {name} 发送 {position} 职位的录用邀请。",
  msgStatusByYou: "您已将 {name} 的 {position} 职位申请状态更改为 {status}。",
  msgStatusByOther:
    "其他管理员已将 {name} 的 {position} 职位申请状态更改为 {status}。",
  msgPaymentInProgress: "{position} 职位的申请人 {name} 正在付款中。",

  // status names
  status: {
    Pending: "暂无信息",
    Interested: "有意向",
    "Pass Screening": "通过筛选",
    "Not Pass Screening": "未通过筛选",
    "Pass Interview": "录用",
    "Not Pass Interview": "面试未通过",
    "Waiting Payment": "待付款",
    "Payment Success": "付款成功",
    "Payment In Progress": "付款处理中",
    "Payment Expired": "已过期",
    "Interview In Progress": "面试进行中",
    "Waiting Interview": "待面试",
    "Miss Interview": "未参加面试",
  },
};
